
/**
 * 行政审批自然人证件类型
 */
export const userInfoCardType = [
  {name: '身份证',id: 10},
  {name: '士兵证',id: 12},
  {name: '护照',id: 20},
  {name: '警官证',id: 13},
  {name: '港澳居民来往内地通行证',id: 14},
  {name: '军官证',id: 11},
  {name: '台湾居民来往大陆通行证',id: 15},
  {name: '香港身份证',id: 16},
  {name: '澳门身份证',id: 17},
  {name: '台湾身份证',id: 18},
  {name: '其他证件',id: 40},
]

/**
 * 行政审批法人证件类型
 */
export const userCompCardType = [
  {name: '统一社会信用代码',id: 30}
]

/**
 * 性别
 */
export  const userSexType =[
  {title:'男',id:1},
  {title:'女',id:2},
]
